export default {
  '400': {
    title: 'Pedido inválido',
    description: 'Parece que a ligação em que clicou tem um pequeno problema, pelo que não conseguimos processar o seu pedido.',
  },
  '404': {
    title: 'Não encontrado',
    description: 'A página que procura pode ter sido removida, mudado de nome ou estar temporariamente indisponível.',
  },
  '500': {
    title: 'Erro interno do servidor',
    description: 'Ocorreu um erro inesperado. Tente novamente mais tarde.',
  },
  'call-dispatcher': 'Ligar para o despachante',
  'error-code': 'Erro {code}',
  'dispatcher-hint': 'Contacte o despachante da Rx2Go <br /> se vir este erro',
  generic: {
    title: 'Algo correu mal',
    description: 'Algo correu mal',
  },
  'server-error': 'Erro do servidor',
  'cant-request': 'Não foi possível efetuar o pedido',
  'no-order-id': 'Sem número de encomenda',
}
